<template>
    <v-card class="card-header" color="background" height="100%">
        <div class="mobile-header d-md-none">
            <div class="menu-button-container d-md-none">
                <v-app-bar-nav-icon color="dark" class="menu-button" id="menuItem"
                    @click.stop="toggleNavigation"></v-app-bar-nav-icon>
            </div>

            <div class="ml-16 d-flex d-md-none align-center">
                <v-img id="logo" class="logo" :src="brandLogoUrl" :alt="branding.display_name" max-height="50" max-width="180"
                    contain></v-img>
            </div>
        </div>
        <!-- <ProgressBar></ProgressBar> -->

        <v-navigation-drawer app v-model="drawer" :permanent="isDesktop" :temporary="!isDesktop"
            :mini-variant="isDesktop && miniDrawer" mini-variant-width="72" width="292"
            :class="['app-drawer', { 'app-drawer--mini': isDesktop && miniDrawer }]">
            <div class="drawer-brand">
                <div class="drawer-brand-content">
                    <img :class="{ 'default-brand-logo': !branding.logo_url }" :src="brandLogoUrl" :alt="branding.display_name" />
                </div>

                <v-btn icon class="drawer-toggle d-none d-md-flex" id="drawerToggle" @click.stop="toggleNavigation">
                    <v-icon>{{ miniDrawer ? 'mdi-menu' : 'mdi-menu-open' }}</v-icon>
                </v-btn>
            </div>

            <div class="drawer-scroll">
                <v-list dense subheader class="drawer-list" v-for="(menuGroup, index) in sidebarMenu" :key="index">
                    <template v-if="canShowMenuGroup(menuGroup)">
                        <v-subheader class="menu-subheader">{{ menuGroup.name }}</v-subheader>
                        <template v-for="(menuOption, index) in menuGroup.children">
                            <MenuItem v-if="!menuOption.path || $check(menuOption.path, 'GET')" :item="menuOption" :key="index">
                            </MenuItem>
                        </template>
                    </template>
                </v-list>
            </div>

            <div class="drawer-footer">
                <v-menu top offset-y min-width="220" content-class="profile-menu-content">
                    <template v-slot:activator="{ on, attrs }">
                        <button class="sidebar-user" type="button" v-bind="attrs" v-on="on">
                            <v-avatar class="user-avatar" size="38">
                                <span>{{ userInitials }}</span>
                            </v-avatar>

                            <span class="sidebar-user-info">
                                <strong>{{ user.name }}</strong>
                                <small>{{ user.email }}</small>
                            </span>

                            <v-icon size="18" class="sidebar-user-chevron">mdi-chevron-up</v-icon>
                        </button>
                    </template>
                    <v-list dense class="profile-menu-list">
                        <template v-for="(menuOption, index) in profileMenu">
                            <v-list-item
                                :key="index"
                                v-if="!menuOption || !menuOption.children"
                                class="profile-menu-item"
                                @click="handleProfileMenuClick(menuOption)"
                            >
                                <v-list-item-icon>
                                    <v-icon>{{ menuOption.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ menuOption.name }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-menu>
            </div>
        </v-navigation-drawer>

        <v-main class="app-main">
            <div class="app-main-content">
                <router-view></router-view>
            </div>

            <footer class="app-content-footer">
                <span>Powered by</span>
                <img src="@/assets/images/logo-mazzitech-light.svg" alt="Mazzitech" />
            </footer>
        </v-main>
    </v-card>
</template>

<script>
// import userApi from "@/common/api/user.api";
import { eventHub } from "@/main";

import router from '../router';

import MenuItem from "@/layouts/components/MenuItem";
//import toolbarMenu from "@/common/data/toolbar-menu.data"
import profileMenu from "@/common/data/profile-menu.data"
import sidebarMenu from "@/common/data/sidebar-menu.data"
import defaultLogo from "@/assets/images/logo-smartpin.png"
import { applyBranding, storedBranding } from "@/services/branding.service"

export default {
    name: "PrivateLayout",

    components: {
        MenuItem
    },

    data() {
        return {
            logoUrl: null,
            branding: storedBranding(),
            menuGroups: [],
            drawer: false,
            miniDrawer: false,
            searchTerm: null,
            user: null,
            displaySettingsMenu: false,
            // toolbarMenu: toolbarMenu,
            sidebarMenu: sidebarMenu,
            profileMenu: profileMenu
        };
    },

    computed: {
        routeName() {
            return this.$route.name;
        },

        isDesktop() {
            return this.$vuetify.breakpoint.mdAndUp;
        },

        userInitials() {
            const name = (this.user && this.user.name) || "Administrador";
            return name
                .split(" ")
                .filter(Boolean)
                .slice(0, 2)
                .map((part) => part[0])
                .join("")
                .toUpperCase();
        },

        isMasterAdmin() {
            const user = this.user || {};
            const currentProfile = user.current_profile || {};
            const profileTypes = user.profile_types || [];

            return Number(user.type) === 99
                || Number(currentProfile.type) === 99
                || profileTypes.includes("master_admin");
        },
        brandLogoUrl() { return this.branding.logo_url || defaultLogo; },
    },

    created() {
        let storedUser = {};

        try {
            storedUser = JSON.parse(localStorage.getItem("user") || "{}");
        } catch (error) {
            storedUser = {};
        }

        const rootUser = this.$root.user && (this.$root.user.data || this.$root.user);
        this.user = rootUser && (rootUser.name || rootUser.email) ? rootUser : (storedUser.data || storedUser || {});
        const profileBranding = this.user.current_profile && this.user.current_profile.branding;
        if (profileBranding) this.branding = applyBranding(profileBranding, this.$vuetify);
        this.miniDrawer = localStorage.getItem("drawerMini") === "true";
        this.drawer = this.isDesktop;

        eventHub.$on("close-menu", () => {
            this.closeMenu();
        });

        eventHub.$on("logout", this.logout);
        eventHub.$on("BRANDING_UPDATED", (branding) => {
            this.branding = applyBranding(branding, this.$vuetify);
        })

        this.setActionButtons();

    },

    destroyed() {
        eventHub.$off("THEME_UPDATED");
        eventHub.$off("close-menu");
        eventHub.$off("logout", this.logout);
        eventHub.$off("BRANDING_UPDATED");
    },

    methods: {
        toggleNavigation() {
            if (this.isDesktop) {
                this.miniDrawer = !this.miniDrawer;
                localStorage.setItem("drawerMini", String(this.miniDrawer));
                return;
            }

            this.drawer = !this.drawer;
        },

        closeMenu() {
            if (!this.isDesktop) {
                this.drawer = false;
            }
        },

        handleProfileMenuClick(item) {
            if (!item) return;

            if (item.event) {
                eventHub.$emit(item.event);
                return;
            }

            if (item.route && this.$route.path !== item.route) {
                this.$router.push(item.route);
            }
        },

        canShowMenuGroup(menuGroup) {
            if (menuGroup.masterOnly && !this.isMasterAdmin) return false;

            return menuGroup.children.some((menuOption) => !menuOption.path || this.$check(menuOption.path, "GET"));
        },

        setActionButtons() {
            // Grupo
        },

        // closeMenu() {
        //     this.$refs.menu.save()
        // },

        menuActionClick(event) {
            event.preventDefault()
        },

        async logout() {
            // if (await this.$root.$confirm(true, "user.logout")) {
            //     userApi.clearcurrentUser;
            //     this.$router.push({ name: "Login" });
            // }

            localStorage.clear();
            if (this.$route.path !== "/login") {
                router.push("/login");
            }
        },
    },
};
</script>
  
<style scoped lang="scss" >
.title {
    color: var(--v-primary-base);
    text-decoration: none;
}

.card-header {
    border-radius: 0px;
    background: #f6f8fb !important;
}

.mobile-header {
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #e7edf5;
    display: flex;
    height: 72px;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 6;
}

.menu-button-container {
    background-color: #ffffff !important;
    border-right: 1px solid #e7edf5;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 72px;
    text-align: center;
}

.menu-button {
    margin: auto;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
}

.app-header {
    border-bottom: 1px solid #e7edf5 !important;
    z-index: 6 !important;
}

.logo {
    max-height: 42px !important;
}

.logged-user {
    text-align: left;
    margin-right: 10px;
    font-size: 13px;
    font-weight: 400;
    flex-direction: column;

    &-name {
        display: block;
    }

    &-email {
        display: block;
    }
}

.user-avatar {
    background: #dbeafe !important;
    border: 1px solid rgba(255, 255, 255, 0.14);
    box-shadow: none;
    color: #0554b5;
    font-size: 12px;
    font-weight: 800;
}

.app-drawer {
    background: var(--school-sidebar, #0f172a) !important;
    border-right: 1px solid #1e293b;
    z-index: 7 !important;
}

.app-drawer ::v-deep .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.app-drawer--mini {
    overflow-x: hidden;
}

.drawer-brand {
    align-items: center;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    min-height: 78px;
    padding: 18px 18px 18px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    transition: padding 0.2s ease;
}

.drawer-brand-content {
    min-width: 0;
}

.drawer-brand-content img {
    display: block;
    width: 138px;
    height: auto;
    object-fit: contain;
    transition: width 0.2s ease;
}

.drawer-brand-content img.default-brand-logo { filter: brightness(0) invert(1); }

.drawer-toggle {
    margin-top: 0;
    color: #cbd5e1 !important;
}

.drawer-list {
    padding: 7px 9px;
}

.drawer-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding-bottom: 8px;
    scrollbar-width: none;
}

.drawer-scroll::-webkit-scrollbar {
    display: none;
}

.drawer-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    flex: 0 0 auto;
    padding: 14px 12px 12px;
}

.sidebar-user {
    align-items: center;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: #f8fafc;
    display: flex;
    gap: 10px;
    min-height: 54px;
    padding: 8px 10px;
    text-align: left;
    width: 100%;
}

.sidebar-user-info {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
}

.sidebar-user-info strong,
.sidebar-user-info small {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sidebar-user-info strong {
    color: #f8fafc;
    font-size: 13px;
    font-weight: 800;
    line-height: 18px;
}

.sidebar-user-info small {
    color: #94a3b8;
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
}

.sidebar-user-chevron {
    color: #94a3b8;
}

.profile-menu-content {
    border-radius: 8px !important;
    box-shadow: 0 16px 36px rgba(15, 23, 42, 0.16) !important;
    overflow: hidden;
}

.profile-menu-list {
    background: #ffffff !important;
    padding: 6px !important;
}

.profile-menu-item {
    border-radius: 6px;
    color: #111827 !important;
    min-height: 42px;
}

.profile-menu-item:hover {
    background: #f3f6fb !important;
}

.profile-menu-item .v-icon,
.profile-menu-item .v-list-item__title {
    color: #111827 !important;
}

.profile-menu-item .v-list-item__icon {
    margin: 10px 12px 10px 0 !important;
}

.profile-menu-item .v-list-item__title {
    font-size: 13px;
    font-weight: 700;
}

.app-drawer--mini .drawer-brand {
    align-items: center;
    justify-content: center;
    min-height: 72px;
    padding: 12px 8px;
}

.app-drawer--mini .drawer-brand-content,
.app-drawer--mini .menu-subheader {
    display: none;
}

.app-drawer--mini .drawer-toggle {
    margin: 0;
}

.app-drawer--mini .drawer-list {
    padding: 7px 8px;
}

.app-drawer--mini .drawer-footer {
    padding: 10px 8px;
}

.app-drawer--mini .sidebar-user {
    justify-content: center;
    min-height: 46px;
    padding: 4px;
}

.app-drawer--mini .sidebar-user-info,
.app-drawer--mini .sidebar-user-chevron {
    display: none;
}

.app-drawer--mini ::v-deep .v-list-item {
    justify-content: center;
    padding: 0 12px !important;
}

.app-drawer--mini ::v-deep .v-list-item__icon {
    margin: 7px 0 !important;
}

.app-drawer--mini ::v-deep .v-list-item__content {
    display: none;
}

.menu-subheader {
    padding-left: 12px;
    color: #94a3b8;
    // font-family: Montserrat;
    font-size: 10px;
    font-style: normal;
    font-weight: 800;
    height: 24px;
    line-height: 24px;
    letter-spacing: 0.08em;
    margin-top: 2px;
    text-transform: uppercase;
}

.menu-title {
    padding-left: 16px;
    color: var(--v-important-base);
    // font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
}

.description-select-company {
    color: var(--v-dark-base);
}

.app-main {
    min-height: 100vh;
    background: #f6f8fb;
    padding: 18px 32px 28px !important;
}

.app-main ::v-deep .v-main__wrap {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 46px);
}

.app-main-content {
    flex: 1 0 auto;
}

.app-content-footer {
    align-items: center;
    color: #94a3b8;
    display: flex;
    flex: 0 0 auto;
    gap: 8px;
    justify-content: center;
    margin-top: 32px;
    min-height: 36px;
    padding: 12px 0 2px;
}

.app-content-footer span {
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    white-space: nowrap;
}

.app-content-footer img {
    display: block;
    filter: brightness(0) saturate(100%) invert(33%) sepia(13%) saturate(1050%) hue-rotate(179deg) brightness(88%) contrast(89%);
    height: 17px;
    max-width: 112px;
    object-fit: contain;
}

@media only screen and (max-width: 960px) {
    .app-main {
        padding: 84px 16px 16px !important;
    }

    .app-main ::v-deep .v-main__wrap {
        min-height: calc(100vh - 100px);
    }
}
</style>
